module.exports = __webpack_public_path__ + "assets/father-math-e49e548bf917bbd49e3719a1337f8270.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/father-math.png
// module id = 511
// module chunks = 1